export const getMeianoite = state => {
  return state.meianoite;
};

export const getPacientesInternados = state => {
  return state.pacientesInternados;
};

export const getErrorCns = state => {
  return state.errorCns;
};

export const getHistoricoInternacoes = state => {
    return state.historicoInternacoes.historico;
};

export const getHistoricoInternacoesError = state => {
    return state.historicoInternacoes.error;
};

export const getHistoricoMovimentacao = state => {
    return state.historicoMovimentacao.movimentacao;
};

export const getLongaPermanencia = state => {
    return state.longaPermanencia;
  };
  